import React, {Component, Fragment} from 'react';
import {observer,inject} from "mobx-react";
import {reaction,toJS} from "mobx";
import { DropTarget, DragDropContainer } from 'react-drag-drop-container';
import SectInside from "./SectionTree";
import {StoreContext} from "../stores/contexts";

class Section extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      drag_enter_pos:''
    };

    reaction(()=>{
      return this.props.drag_manual_enabled;
    },(enabled)=>{
      if(!enabled) {
        this.setState({ drag_enter_pos:"" });
      }
    })

  }
  isHaveChildrens()
  {
    return this.context.treeStore.have_children[this.props.item.id]?true:false;
  }
  isOpened() {
    return this.context.treeStore.opened_sections[this.props.item.id];
  }
  locateSection() {
    this.context.searchStore.selectTree(this.props.item);
  }
  renderFindMe() {
    if(this.props.search) {
      return (
        <i onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.locateSection(); }} className="pa mdi mdi-crosshairs" style={{left:-18 }}></i>
      );
    }
    return null;
  }
  renderHidden() {
    if(this.props.item.id!=='root' && this.props.item.id!=='all' && this.props.item.published != '1') {
      return (
        <i className="mdi mdi-eye-off-outline pright5 op50"></i>
      );
    }
    return null;
  }
  renderOpenedMarker() {
    if(this.props.search) {
      return null;
    }
    if(this.isHaveChildrens()) {
      if(this.context.treeStore.opened_sections[this.props.item.id]) {
        return <i onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.toggleSection(); }} className="pa mdi mdi-chevron-down" style={{left:-15}}></i>
      } else {
        return <i onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.toggleSection(); }} className="pa mdi mdi-chevron-right" style={{left:-15}}></i>
      }
    } else {

    }
  }
  openSection() {
    if(this.isHaveChildrens()) {
      this.context.treeStore.openSection(this.props.item.id);
    }
  }
  toggleSection() {
    if(this.isHaveChildrens()) {
      this.context.treeStore.toggleSection(this.props.item.id);
    }
  }
  selectSection() {
    this.context.treeStore.selectSection(this.props.item.id);
  }
  sectionClick() {
    this.openSection();
    this.selectSection();
  }
  isDragging() {
    if(

      this.context.dragStore.drag_type=="section" &&
      this.context.dragStore.drag_source.id == this.props.item.id
    ) {
      return true;
    }
    return false;
  }
  componentDidMount() {
    reaction(
      ()=>{
        return this.context.dragStore.dragging
      },
      (data)=>{
        if(!data) {
          if(this.state.drag_enter_pos) {
            this.setState({drag_enter_pos: ''});
          }
        }

    });
  }
  dropHit(type,data) {
    if(this.context.dragStore.drag_manual_enabled || this.context.dragStore.drag_custom_enabled) {
      this.context.communicatorStore.pushMessage({
        type:"output",
        command:"drop_hit",
        drop_type:type,
        section:{ id:this.props.item.id, [this.context.treeStore.par.name_field]:this.props.item[this.context.treeStore.par.name_field] },
        data:toJS(this.context.dragStore.drag_manual_data),
      });
    } else {
      console.log('DROP HIT!', type, toJS(data.dragData));
      this.context.dragStore.drop("section", toJS(data.dragData), type, this.props.item);
    }
  }
  render() {
    return (
      <div className={` ${this.isDragging()?'transp100':''}`}>
        <DragDropContainer
          dragData={this.props.item}
          noDragging={!this.context.dragStore.drag_enabled || this.props.item.disable_drag}
          returnToBase={true}
          dragClone={true}
          targetKey="section"
          onDragStart={()=>{
            console.log("drag_start");
            this.context.dragStore.dragging=true;
            this.context.dragStore.drag_type="section";
            this.context.dragStore.drag_source=this.props.item;
          }}
          onDragEnd={()=>{
            this.context.dragStore.dragging=false;
            this.context.dragStore.drag_type="";
            this.context.dragStore.drag_source={};
            console.log("DRAG END!!!");
          }}
          onDrop={(data)=>{
            console.log("DROP!!!",data);
          }}
          elementProps={{ style:{ display:'block', position:'static'}}}
        >
          {/*  clear tdni  db lh14 hpadd10 submenuItem  selected */}
          <div onClick={()=>{ this.sectionClick(); }} className={`pr pointer cdb lh14 pright10 ${this.props.search?'pleft20':'pleft15'} submenuItem  treeSection ${this.context.treeStore.selected_section==this.props.item.id?"selected":""}`}>
            <span className={`pr db`} style={{marginLeft:(this.props.level-1)*15}} >
              {this.renderOpenedMarker()}
              {this.renderFindMe()}
              {this.renderHidden()}
              {this.props.item[this.context.treeStore.par.name_field]}
            </span>
            {this.context.dragStore.drag_manual_enabled?(
              <div
                onDragLeave={()=>{ this.setState({ drag_enter_pos:"" }); }}
                onDragOver={(e)=>{ e.preventDefault(); this.setState({ drag_enter_pos:"inside" });  }}
                onDragEnter={(e)=>{ e.preventDefault(); this.setState({ drag_enter_pos:"inside" });  }}
                onDrop={()=>{ this.dropHit('inside', this.props.drag_manual_enabled); this.setState({ drag_enter_pos:"" }); }}
                className={`pa w100 ptop10 bg-b1-op50 ${this.state.drag_enter_pos=="inside"?"":"transp100"}`}
                style={{top:10,height:'calc(100% - 20px)'}}></div>
            ):null}
            {this.context.dragStore.drag_custom_enabled?(
              <DropTarget
                targetKey={this.context.dragStore.drag_custom_enabled}
                onDragEnter={()=>{ this.setState({ drag_enter_pos:'inside' }); }}
                onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
                onHit={(data)=>{ this.dropHit('inside', this.props.drag_manual_enabled); this.setState({ drag_enter_pos:"" });}}
              >
                <div className={`pa w100 ptop10 bg-b1-op50 ${this.state.drag_enter_pos=="inside"?"":"transp100"}`}
                  style={{top:10,height:'calc(100% - 20px)'}}></div>
              </DropTarget>
            ):null}
            {this.context.dragStore.drag_enabled && this.context.dragStore.drag_type && !this.isDragging()?(
              <>
              {!this.props.item.disable_drag?(<DropTarget
                  targetKey="section"
                  onDragEnter={()=>{ this.setState({ drag_enter_pos:'top' }); }}
                  onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
                  onHit={(data)=>{ this.dropHit('before',data); }}
                >
                  <div style={{top:-5}} className={`pa pa-tl w100 ptop10 bg-b1-op50 ${this.state.drag_enter_pos=="top"?"":"transp100"}`}></div>
                </DropTarget>
              ):null}

              {!this.props.item.disable_drag?(<DropTarget
                  targetKey="section"
                  onDragEnter={()=>{ this.setState({ drag_enter_pos:'bottom' }); }}
                  onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
                  onHit={(data)=>{ this.dropHit('after',data); }}
                >
                  <div style={{bottom:-5}} className={`pa pa-bl w100 ptop10 bg-b1-op50 ${this.state.drag_enter_pos=="bottom"?"":"transp100"}`}></div>
                </DropTarget>
              ):null}
              {!this.props.item.disable_drop?(<DropTarget
                  targetKey="section"
                  onDragEnter={()=>{ this.setState({ drag_enter_pos:'inside' }); }}
                  onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
                  onHit={(data)=>{ this.dropHit('inside',data); }}
                >
                  <div className={`pa w100 ptop10 bg-b1-op50 ${this.state.drag_enter_pos=="inside"?"":"transp100"}`} style={{top:10,height:'calc(100% - 20px)'}}></div>
                </DropTarget>
              ):null}
              </>
            ):null}
          </div>
        </DragDropContainer>
        {!this.props.search && this.isOpened()?<SectInside level={this.props.level+1} section={this.props.item.id} />:null}
      </div>
    )
  }
}

// export default inject("treeStore","searchStore","dragStore","communicatorStore")(observer(Section));
export default observer(Section);